import { ByteFormatter, DateFormatter, daysLeft, pctDoneDate, pctDoneValue } from "../../Service/Helper/Utils";

export function ProgressTrackCard ({
        min = 0,
        max = 0,
        isDate = false,
        isGb = false,
        isBanner = false,
        percentText = "Terpakai",
        progressText = "Hari Tersisa"
    }) {
    const valLeft = !isDate ? (Number(max) - Number(min)) : daysLeft(max)
    const prog = !isDate ? pctDoneValue(min, max) : pctDoneDate(min, max)
    const colorPalleteStart = !isBanner ? "var(--txt)" : "var(--surface3)"

    console.log({
        min,
        max,
        valLeft,
        prog,
        isDate,
        isGb,
        percentText,
        progressText
    })
    return (<>
        <div style={{ marginBottom:14 }}>
          <div className="flex justify-between txt-muted"
                style={{
                    fontSize: 12,
                    marginBottom: 6
                }}>
                    {!isDate
                        ? (<>
                            <span style={{ color: colorPalleteStart }}>{ByteFormatter(min)}</span>
                            <span>{ByteFormatter(max)}</span>
                        </>)
                        : (<>
                            <span  style={{ color: colorPalleteStart }}>{DateFormatter(min)}</span>
                            <span>{DateFormatter(max)}</span>
                        </>)
                    }
            </div>
          <div className="progress-track">
                <div className="progress-fill"
                    style={{ width:`${prog}%` }} />
                </div>
          <div className="flex justify-between"
                style={{
                    fontSize: 11,
                    color: colorPalleteStart,
                    marginTop: 5
                }}>
            <span>{prog}% {percentText}</span>
            <span style={{
                color: (valLeft <= 7)
                    ? "var(--danger)"
                    : "var(--txt)",
                fontWeight: (valLeft <= 7)
                            ? 700 : 400
            }}>{!isDate ? ByteFormatter(valLeft) : valLeft} {progressText}</span>
          </div>

        <div className="rounded-row">
          <span className="txt-muted">Sisa Kuota FUP</span>
          <span className="txt-val">
            {`${100 - prog}%`}
          </span>
        </div>
        <div className="rounded-row">
          <span className="txt-muted">Kuota Tersisa</span>
          <span className="txt-val">{ByteFormatter(valLeft ?? 0)}</span>
        </div>
        </div>
    </>)
}